import { ContatoDadoSituacao, ContatoDataComemorativa, ContatoNivel, ContatoSecao, ContatoStatus, ContatoTipo, } from '../generated/backend-enums.js';
export { ContatoDadoSituacao, ContatoDataComemorativa, ContatoNivel, ContatoSecao, ContatoStatus, ContatoTipo, };
/** Rótulos das seções, no vocabulário de quem usa a tela. O prazo de vencimento vive no backend. */
export const ContatoSecaoMap = {
    [ContatoSecao.ENDERECO]: 'Endereço',
    [ContatoSecao.TELEFONE_PESSOAL]: 'Telefone pessoal',
    [ContatoSecao.TELEFONE_CORPORATIVO]: 'Telefone corporativo',
    [ContatoSecao.EMAIL]: 'E-mail',
    [ContatoSecao.PERFIL]: 'Perfil',
};
/** Rótulos dos tipos de contato. Tipo novo no enum sem rótulo aqui não compila. */
export const ContatoTipoMap = {
    [ContatoTipo.CLIENTE]: 'Cliente',
    [ContatoTipo.FORNECEDOR]: 'Fornecedor',
    [ContatoTipo.PARCEIRO]: 'Parceiro',
};
/** Rótulos do relacionamento (`nivel`) do contato. Nível novo no enum sem rótulo aqui não compila. */
export const ContatoNivelMap = {
    [ContatoNivel.ESTRATEGICO]: 'I - Estratégico',
    [ContatoNivel.IMPORTANTE]: 'II - Importante',
    [ContatoNivel.NORMAL]: 'III - Normal',
};
/** Rótulos das datas comemorativas. Data nova no enum sem rótulo aqui não compila. */
export const ContatoDataComemorativaMap = {
    [ContatoDataComemorativa.ANIVERSARIO]: 'Aniversário',
    [ContatoDataComemorativa.DIA_DAS_CRIANCAS]: 'Dia das Crianças',
    [ContatoDataComemorativa.DIA_DAS_MAES]: 'Dia das Mães',
    [ContatoDataComemorativa.DIA_DOS_PAIS]: 'Dia dos Pais',
};
export const ContatoStatusMap = {
    [ContatoStatus.ATIVO]: 'Ativo',
    [ContatoStatus.INATIVO]: 'Inativo',
    [ContatoStatus.ANONIMIZADO]: 'Eliminado a pedido',
    [ContatoStatus.MESCLADO]: 'Mesclado em outro contato',
};
export const ContatoDadoSituacaoMap = {
    [ContatoDadoSituacao.EM_DIA]: 'Em dia',
    [ContatoDadoSituacao.PODE_ESTAR_DESATUALIZADO]: 'Pode estar desatualizado',
};
